import React from 'react';
import { Surface } from '@ukpostbox/frontend-framework';
import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';
import { RenderBatchSectionType } from '../../Types/ForwardingBatchTypes';
import { BatchYesNo } from '../Controls/BatchYesNo';

function BatchDetails(props: RenderBatchSectionType) {
	const { documentsOnly, UpdateDocumentsOnly } = useForwardingBatchProvider();

	return (
		<div>
			<h5 className='mb-xs'>
				Step {props.sectionIndex}: {props.section.name}
			</h5>

			<Surface extraClass='p-md'>
				<BatchYesNo
					id='documentsOnly'
					index={0}
					isChecked={documentsOnly}
					label='Does your batch only contain documents?'
					groupName='documentsOnly'
					checkOnly
					readOnly={props.readOnly}
					onChange={(e: any) => {
						UpdateDocumentsOnly(e.checked);
					}}
				/>
			</Surface>
		</div>
	);
}

export { BatchDetails };
